module.exports = __webpack_public_path__ + "img/china-logo.0a757cdb.png";